import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import Carousel from "../../Carousel/Carousel"
import ReviewCard from "./ReviewCard"
import { getImageUrl } from "../../../adapters/cloudinary.adapters"
import { breakpoints } from '../../../constants/global'
import { btnTooltipPrevious, btnTooltipNext } from '../../../constants'
import reviewsStyles from "../../../styles/components/Product/Reviews/Reviews-tw-styles"
import LeftArrow from "../../Icons/LeftArrow"
import RightArrow from "../../Icons/RightArrow"

const Reviews = ({ content }) => {
    const [isMobile, setScreenSize] = useState(true)
    const [PrevButtonHidden, setPrevButtonHidden] = useState(true)
    const [NextButtonHidden, setNextButtonHidden] = useState(false)
    const carouselRef = useRef(null)
    useEffect(() => {
        setScreenSize(window.innerWidth <= breakpoints.sP)
        window.addEventListener("resize",() =>{
            setScreenSize(window.innerWidth <= breakpoints.sP)
        })
    }, [])

    const styles = reviewsStyles[content.styles || 'default'] || reviewsStyles['default']
    const { reviews } = styles
    const cards = content.reviewsCollection && content.reviewsCollection.items
    const flickityOptions = {
        cellAlign: "left",
        pageDots: false,
        selectedAttraction: 0.2,
        friction: 0.9,
        dragThreshold: 1,
        prevNextButtons: false
    }

    const addClassForOpacity = () => {
        const actualInnerWidth = document.body.clientWidth
        const reviewCards = document.getElementsByClassName("ReviewCard")
        for (let i = 0; i < reviewCards.length; i++) {
            const cardWidth = reviewCards[i].clientWidth
            const cardLeftVal = reviewCards[i].getBoundingClientRect().left
            reviewCards[i].classList.remove("display-off")
            if (cardLeftVal + cardWidth > actualInnerWidth) {
                reviewCards[i].classList.add("display-off")
            }
        }
    }

    const setRef = (flickityObj) => {
        flickityObj.resize()
        flickityObj.on('ready', addClassForOpacity)
        flickityObj.on('settle', addClassForOpacity)
        carouselRef.current = flickityObj
        carouselRef.current.on('change', handleSlideChange)
       
    }

    const getCards = (data) => {
        return data &&
            data.map(cardData => {
                {
                    return (
                        <React.Fragment key={cardData.sys.id}>
                            <ReviewCard cardData={cardData} singleCheck={content && content.singleReview} />
                        </React.Fragment>
                    )
                }
            })
    }

    const handleSlideChange = index => {
        setPrevButtonHidden(index === 0)
        setNextButtonHidden((index + 1) >= carouselRef.current.cells.length)
    }

    const handleNext = () => {
        carouselRef.current.next()
    }

    const handlePrevious = () => {
        carouselRef.current.previous()
    }

    const CustomSliderCheck = (prevButton, isPrevButtonHidden, nextButton, isNextButtonHidden) => {
       
        return (
            <><button
                aria-label={btnTooltipPrevious}
                onClick={handlePrevious}
                title={btnTooltipPrevious}
                className={prevButton}
                disabled={isPrevButtonHidden}
            >
                <LeftArrow />
            </button><button
                aria-label={btnTooltipNext}
                onClick={handleNext}
                title={btnTooltipNext}
                className={nextButton}
                disabled={isNextButtonHidden}
            >
                <RightArrow />
            </button></>
        )
    }

    return (
        
        <div
            className={reviews}
            {... !isMobile && content.backgroundImage && { style: { backgroundImage: `url(${getImageUrl(content.backgroundImage.url)}` } }}
        >
            {!isMobile && cards.length > 1 && (
                <div className={'slider'}>
                    {CustomSliderCheck(
                        styles.prevButton,
                        PrevButtonHidden,
                        styles.nextButton,
                        NextButtonHidden
                    )}
                </div>
            )}
            { (cards.length > 1) ?
                <Carousel options={flickityOptions}
                    flickityRefCallback={ref => setRef(ref)}
                    className={"slider"}>
                    {getCards(cards)}
                </Carousel> :
                <div>
                    {getCards(cards)}
                </div>
            }

            {
                isMobile && content.foregroundImage && <img src={content.foregroundImage.url} alt={content.foregroundImage.title} />
            }

        </div>
    )
}
Reviews.propTypes = {
    content: PropTypes.object
}
export default Reviews
